/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import * as constants from '@veeam/components/lib/helpers/constants';
import { colors } from '@veeam/components/lib/themes/colors/colors';
import { BASE_BORDER_WIDTH } from '@veeam/components/lib/helpers/constants';

import { SelectionMode } from '../../../enums';

export const SelectionHeaderWrapper = styled.div<{ selectionMode: SelectionMode; }>`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  background-color: ${props => props.selectionMode === SelectionMode.AllPages ? colors.Y50 : colors.G000};
  height: ${constants.SIZE_XL};
  border-bottom: ${BASE_BORDER_WIDTH} solid ${colors.G250};
  padding: 0 ${constants.SPACING_S};
`;
